import React, {Component} from 'react';

const DefaultFallback = () => (
  <div className="async-route-fallback" aria-hidden="true" />
);

const asyncComponent = (importComponent, Fallback = DefaultFallback, { prefetch = false } = {}) => {
    const pending = prefetch ? importComponent() : null;

    return class extends Component {
        state = {
            component: null
        }

        componentDidMount() {
            (pending || importComponent()).then(cmp => {
                this.setState({component: cmp.default});
            });
        }

        render() {
            const C = this.state.component;
            return C ? <C {...this.props}/> : <Fallback />;
        }
    }
};

export default asyncComponent;
